/*eslint-disable */
import React, { FC, memo, useMemo, useEffect, useCallback } from "react";

import { areEqualShallow } from "Utils/areEqual";
import TrailsList from "Components/TrailsList";
import { setPathStops, setStopState, StopState } from "Containers/Stops";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "Utils/browserProperties";
import { setShowSearchOptions } from "Containers/CampusMap";

interface Props {
  setTrails: (val: any) => void;
  setShowTrails: (showTrails: boolean) => void;
  showTrails: boolean;
  selectedTrails: number;
  setSelectedTrails: (trails: number) => void;
  showDefaultMobileSearchOptions: boolean;
  setShowDefaultMobileSearchOptions: (status: boolean) => void;
  selectedTrail: string;
  setSelectedTrail: (trail: string) => void;
}

// Add the points to an object, for quick access, when rendering trails.
// Each entry, will be associated with a trail, using the index number.  This will also be associated with each trail button created, using the same index
const generatePathStops = (trails: any[]) => {
  const pathStops = {};
  trails.forEach(({ Stops }, index: number) => {
    pathStops[index] = Stops;
  });
  return pathStops;
};

const TrailsListContainer: FC<Props> = memo(
  ({
    setTrails,
    setShowTrails,
    showTrails,
    selectedTrails,
    setSelectedTrails,
    showDefaultMobileSearchOptions,
    setShowDefaultMobileSearchOptions,
    selectedTrail,
    setSelectedTrail,
  }: Props) => {
    const dispatch = useDispatch();
    // We need to generate the pathStops for each Trail, and pass the array into the TrailListComponent

    const { suggestedTrails } = useSelector(
      (selectors: any) => selectors.trails
    );
    const view = useSelector((store: any) => store.searchOptionsView.view);

    // We just want an object containing an array of points.
    // let's only do it once, until suggestions change.
    const pathStops = useMemo(() => generatePathStops(suggestedTrails), [
      suggestedTrails,
    ]);

    useEffect(() => {
      // Only dispatch if the value is not -1.  Get the points array, associated with the index of the button that was clicked.
      if (selectedTrails >= 0) {
        //Get the selected Trail
        const selectedPathStops = pathStops[selectedTrails] || [];

        let selectedStopIds = selectedPathStops.map((stop) =>
          Number(stop.stopid)
        );
        //Dispatch to render to the map.
        dispatch(setPathStops(selectedPathStops));
        dispatch(setStopState(selectedStopIds, StopState.Selected));
      }
    }, [selectedTrails]);

    const trailButtonClick = useCallback(
      (suggestion: any, identifier: string, idx: number) => {
        //Store the trail being selected.
        setTrails(suggestion);

        // Dispatch the trails we want to display
        if (setSelectedTrails) setSelectedTrails(idx);

        //if mobile, we want to keep the searchOptions visisible
        if (isMobile) {
          dispatch(setShowSearchOptions(true));
        }
      },
      [showTrails, setShowTrails, showDefaultMobileSearchOptions]
    );

    useEffect(() => {
      const trailsContainer = document.getElementById("searchOptionsTitle")
      if (view === "trails" && trailsContainer) {
        trailsContainer.focus();
      }
    }, [view])

    return (
      <TrailsList
        suggestions={suggestedTrails}
        selectedTrail={selectedTrail}
        trailButtonClick={trailButtonClick}
        showTrails={showTrails}
      />
    );
  },
  areEqualShallow
);

export default TrailsListContainer;
try {
    // @ts-ignore
    TrailsList.displayName = "TrailsList";
    // @ts-ignore
    TrailsList.__docgenInfo = { "description": "", "displayName": "TrailsList", "props": { "setTrails": { "defaultValue": null, "description": "", "name": "setTrails", "required": true, "type": { "name": "(val: any) => void" } }, "setShowTrails": { "defaultValue": null, "description": "", "name": "setShowTrails", "required": true, "type": { "name": "(showTrails: boolean) => void" } }, "showTrails": { "defaultValue": null, "description": "", "name": "showTrails", "required": true, "type": { "name": "boolean" } }, "selectedTrails": { "defaultValue": null, "description": "", "name": "selectedTrails", "required": true, "type": { "name": "number" } }, "setSelectedTrails": { "defaultValue": null, "description": "", "name": "setSelectedTrails", "required": true, "type": { "name": "(trails: number) => void" } }, "showDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "showDefaultMobileSearchOptions", "required": true, "type": { "name": "boolean" } }, "setShowDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "setShowDefaultMobileSearchOptions", "required": true, "type": { "name": "(status: boolean) => void" } }, "selectedTrail": { "defaultValue": null, "description": "", "name": "selectedTrail", "required": true, "type": { "name": "string" } }, "setSelectedTrail": { "defaultValue": null, "description": "", "name": "setSelectedTrail", "required": true, "type": { "name": "(trail: string) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/TrailsList/TrailsList.tsx#TrailsList"] = { docgenInfo: TrailsList.__docgenInfo, name: "TrailsList", path: "src/shared/containers/TrailsList/TrailsList.tsx#TrailsList" };
}
catch (__react_docgen_typescript_loader_error) { }